// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"WheelOverlay_closeIcon__3lvgY"};